import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { FormState, passwordRegex } from '@opu/utils';
import { useHistory, useLocation } from 'react-router-dom';
import AxiosInstance from '../../../helpers/AxiosInstance';
import { useTranslation } from 'react-i18next';

const useForm = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [resetToken, setResetToken] = useState('');
  const [resetEmail, setResetEmail] = useState('');
  const [showResetPassword, setShowResetPassword] = useState(true);

  useEffect(() => {
    const queries = new URLSearchParams(location.search);
    const token = queries.get('token');
    const email = queries.get('email')?.replace(' ', '+');

    if (!token) {
      setShowResetPassword(false);
      return;
    }

    setResetToken(token);
    setResetEmail(email || '');
  }, []);

  const resetPassword = () => {
    if (!resetToken) {
      Swal.fire(t('ERROR_INVALID_CODE'), '', 'error');
      return;
    }

    setLoading(true);
    AxiosInstance.post(`/auth/reset-password`, {
      token: resetToken,
      password: formState.inputValues.password,
      password_confirm: formState.inputValues.password_confirm,
    })
      .then(async () => {
        await Swal.fire(t('reset-password.successful'), '', 'success').then(() => {
          window.location.href = window.location.origin;
        });
      })
      .catch(() => {
        Swal.fire(t('ERROR_INVALID_CODE'), '', 'error');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const resendResetEmail = () => {
    if (!resetEmail) {
      history.push('/password-recovery');
      return;
    }

    setLoading(true);
    AxiosInstance.post(`/auth/send-password-recovery-email`, { email: resetEmail, role: 'admin' })
      .then(() => {
        Swal.fire(t('PASSWORD_RESET_SUCCESS'), '', 'success');
      })
      .catch(() => {
        Swal.fire(t('PASSWORD_RESET_FAILED'), '', 'error');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const inputValues = {
    password: { value: '', validate: { required: true, min: 8, pattern: passwordRegex } },
    password_confirm: { value: '', validate: { required: true } },
  };
  const { formState, submitHandler, field } = FormState(inputValues, resetPassword);

  return {
    submitHandler,
    field,
    loading,
    showResetPassword,
    resendResetEmail,
  };
};

export default useForm;
